import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import adjustForTimeZone from './adjustForTimeZone';

/**
 * Capitalizes the first letter on the pretty formatted date, so that it ajusts to
 * spanish date writing conventions (uppercase month).
 *
 * @param source - The pretty formatted date
 */
function capitalize(source: string): string {
  return source.charAt(0).toUpperCase() + source.slice(1);
}

/**
 * Returns a string representing a date with a format similar to this:
 * Abril 4 2020 - 12:55 p.m.
 * Note that the month is in spanish. This method will take the same timezone offset
 * considerations as dateFromServerString.
 *
 * @param source - The date to be converted
 * @param adjusted - If true, the date will auto adjust to the current timezone
 */
export default function prettyDateFromServerString(
  source: string,
  adjusted = true,
): string {
  try {
    let date: Date;
    if (adjusted) {
      date = adjustForTimeZone(source);
    } else {
      date = new Date(source);
    }
    return capitalize(format(date, 'LLLL d yyyy - hh:mm aaaa', { locale: es }));
  } catch (e) {
    return '';
  }
}
